<div class="dialog-container" *ngIf="!success">
  <div class="dialog-header">
    <span class="w-36"></span>
    <h2 class="title">{{ labelMap.GET_STARTED_WITH_UVENTEX }}</h2>
    <button
      class="close-button"
      mat-icon-button
      (click)="closeDialog()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <hr class="small" />
  <div class="dialog-content">
    <div class="second-section">
      <img src="/assets/icons/uventex-happy-icon.svg" alt="Logo" class="logo" />
      <div class="p-second-section">
        <p>{{ labelMap.GET_STARTED_WE_ARE_EXCITED }}</p>
        <p>
          {{ labelMap.GET_STARTED_PLESASE_SHARE }}
        </p>
      </div>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="custom-form-field">
        <label class="label-w">{{ labelMap.NAME }}</label>
        <div class="custom-mat-input">
          <div class="input-text">
            <input matInput type="text" formControlName="name" />
          </div>
        </div>
      </div>

      <mat-error class="error" *ngIf="isFieldInvalid('name')">{{
        labelMap.GET_STARTED_PLEASE_ENTER_YOUR_NAME
      }}</mat-error>

      <div class="custom-form-field">
        <label class="label-w">{{ labelMap.EMAIL }}</label>
        <div class="custom-mat-input">
          <div class="input-text">
            <input matInput type="email" formControlName="email" />
          </div>
        </div>
      </div>

      <mat-error *ngIf="isFieldInvalid('email')" class="error">
        <ng-container *ngIf="form.get('email')?.hasError('required')"
          >{{ labelMap.GET_STARTED_PLEASE_ENTER_EMAIL }}
        </ng-container>
        <ng-container *ngIf="form.get('email')?.hasError('email')">{{
          labelMap.GET_STARTED_PLEASE_ENTER_VALID_EMAIL
        }}</ng-container>
      </mat-error>

      <div class="custom-form-field">
        <label class="label-w"> {{ labelMap.GET_STARTED_INTEREST }}</label>
        <mat-form-field appearance="fill" class="custom-select-field">
          <mat-select formControlName="interest" class="custom-input">
            <mat-option
              *ngFor="let option of interestOptions"
              value="{{ option.id }}"
              >{{ option.label }}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="isFieldInvalid('interest')">{{
            labelMap.GET_STARTED_PLEASE_SELECT_AN_OPTION
          }}</mat-error>
        </mat-form-field>
      </div>

      <div class="custom-form-field">
        <label class="label-w">{{ labelMap.MESSAGE }}</label>
        <div class="custom-mat-input-area">
          <div class="input-text-area">
            <textarea
              matInput
              type="text"
              formControlName="message"
              placeholder="{{ labelMap.GET_STARTED_MESSAGE_PLACEHOLDER }}"
            ></textarea>
          </div>
        </div>
      </div>

      <mat-error class="error" *ngIf="isFieldInvalid('message')">{{
        labelMap.GET_STARTED_PLEASE_ENTER_MESSAGE
      }}</mat-error>

      <div class="submit-section">
        <button mat-raised-button color="primary" class="submit-button">
          {{ labelMap.GET_STARTED_SUBMIT_AND_START }}
        </button>
      </div>
    </form>
  </div>
</div>

<div class="dialog-container" *ngIf="success">
  <div class="dialog-header-success">
    <img class="happy-icon" src="/assets/icons/uventex-success-icon.svg" />
    <h2 class="title">{{ labelMap.GET_STARTED_WITH_UVENTEX }}</h2>
    <button
      class="close-button-success"
      mat-icon-button
      (click)="closeDialog()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <hr class="small" />
  <div class="dialog-content-success">
    <span class="main-success-span">
      {{ labelMap.GET_STARTED_THANKS }}
    </span>
    <span class="secondary-success-span">
      {{ labelMap.GET_STARTED_CONTACT }}
    </span>
    <span class="secondary-success-span">
      {{ labelMap.GET_STARTED_IN_MEANTIME }}
    </span>

    <div class="social-media">
      <a
        href="https://www.youtube.com/@Uventex"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/assets/icons/youtube.svg"
          class="social-media-icon"
          alt="Youtube"
        />
      </a>
      <a
        href="https://www.instagram.com/uventexlabs/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/assets/icons/instagram.svg"
          class="social-media-icon"
          alt="Instagram"
        />
      </a>
      <a
        href="https://www.facebook.com/@MYuventex/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/assets/icons/facebook.svg"
          class="social-media-icon"
          alt="Facebook"
        />
      </a>
      <a
        href="https://x.com/uventexlabs"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/assets/icons/x-twitter.svg"
          class="social-media-icon"
          alt="X (Twitter)"
        />
      </a>
    </div>

    <a href="https://uventexlabs.com" target="_blank" class="learn-more">
      {{ labelMap.GET_STARTED_LEARN_MORE }}
    </a>

    <div class="gradient-border">
      <span class="welcome-text" (click)="closeDialog()">
        {{ labelMap.GET_STARTED_WELCOME }}
      </span>
    </div>
  </div>
</div>
